import script from "./SignupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=65ccba03&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ccba03"]])

export default __exports__